<template>
  <div class="responsibility-page">
    <!-- Hero Banner -->
    <section class="responsibility-hero">
      <div class="hero-bg">
		   <img src="/static/shzr.png" alt="社会责任">
	  </div>
     <!-- <div class="hero-content">
        <h1 class="hero-title">社会责任</h1>
        <p class="hero-en-title">CORPORATE SOCIAL RESPONSIBILITY</p>
      </div> -->
    </section>

    <!-- Intro Section -->
    <section class="intro-section">
      <div class="container">
        <div class="intro-header" data-aos="fade-up">
          <div class="intro-watermark">CSR</div>
          <h2 class="intro-title">我们的承诺</h2>
          <div class="intro-divider"></div>
          <p class="intro-text">
            新恒丰集团始终秉承"诚信、创新、高效、共赢"的价值观，在追求企业发展的同时，积极履行社会责任。我们致力于保护环境、回馈社会、对待客户、关爱员工，以实际行动践行企业担当，为社会可持续发展贡献力量。
          </p>
        </div>
      </div>
    </section>

    <!-- 四大责任 -->
    <section class="responsibility-section">
      <div class="container">
        <div class="section-header" data-aos="fade-up">
          <h2 class="section-title">四大责任</h2>
          <div class="section-divider"></div>
        </div>
        <div class="responsibility-grid">
          <div
            v-for="(item, index) in responsibilityList"
            :key="index"
            class="responsibility-card"
            data-aos="fade-up"
            :data-aos-delay="index * 120"
          >
            <div class="card-icon" :style="{ background: item.bgGradient }">
              <i :class="item.icon"></i>
            </div>
            <h3 class="card-title">{{ item.title }}</h3>
            <p class="card-desc">{{ item.description }}</p>
           <!-- <div class="card-action">
              <span>了解更多</span>
              <i class="el-icon-arrow-right"></i>
            </div> -->
          </div>
        </div>
      </div>
    </section>

    <!-- 详细内容区 -->
   <!-- <section class="detail-section">
      <div class="container">
        <div class="detail-block">
          <div class="detail-image" :class="{ 'reverse': true }">
            <img src="https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=green%20forest%20nature%20landscape%20sustainable%20environment%20ecology&image_size=landscape_4_3" alt="保护环境">
            <div class="detail-tag" style="background: linear-gradient(135deg, #10b981, #059669);">ENVIRONMENT</div>
          </div>
          <div class="detail-content">
            <div class="detail-label">保护环境</div>
            <h2 class="detail-heading">守护绿色家园，践行可持续发展</h2>
            <div class="detail-divider"></div>
            <p class="detail-text">
              新恒丰集团高度重视环境保护，在所有咨询项目中严格遵循绿色发展理念。我们积极推广节能环保技术，推动绿色建筑和可持续城市规划，努力将 environmental impact 降至最低。
            </p>
            <div class="detail-stats">
              <div class="stat-item">
                <span class="stat-num">100<span class="unit">%</span></span>
                <span class="stat-label">绿色建筑评价标准覆盖</span>
              </div>
              <div class="stat-item">
                <span class="stat-num">50<span class="unit">+</span></span>
                <span class="stat-label">绿色建筑咨询项目</span>
              </div>
              <div class="stat-item">
                <span class="stat-num">30<span class="unit">%</span></span>
                <span class="stat-label">碳排放减少目标</span>
              </div>
            </div>
          </div>
        </div>

        <div class="detail-block">
          <div class="detail-image">
            <img src="https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=community%20people%20helping%20together%20charity%20social%20responsibility&image_size=landscape_4_3" alt="回馈社会">
            <div class="detail-tag" style="background: linear-gradient(135deg, #f59e0b, #d97706);">SOCIAL</div>
          </div>
          <div class="detail-content">
            <div class="detail-label">回馈社会</div>
            <h2 class="detail-heading">积极承担社会责任，助力公益事业</h2>
            <div class="detail-divider"></div>
            <p class="detail-text">
              新恒丰集团积极参与社会公益事业，通过捐赠、志愿服务、知识帮扶等多种方式回馈社会。我们关注教育、扶贫、健康等领域，努力为社会和谐发展贡献新恒丰力量。
            </p>
            <div class="detail-stats">
              <div class="stat-item">
                <span class="stat-num">200<span class="unit">+</span></span>
                <span class="stat-label">公益捐赠项目</span>
              </div>
              <div class="stat-item">
                <span class="stat-num">1000<span class="unit">+</span></span>
                <span class="stat-label">志愿服务人次</span>
              </div>
              <div class="stat-item">
                <span class="stat-num">500<span class="unit">万</span></span>
                <span class="stat-label">累计公益投入</span>
              </div>
            </div>
          </div>
        </div>

        <div class="detail-block">
          <div class="detail-image" :class="{ 'reverse': true }">
            <img src="https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=professional%20business%20meeting%20handshake%20agreement%20blue%20corporate&image_size=landscape_4_3" alt="对待客户">
            <div class="detail-tag" style="background: linear-gradient(135deg, #1a56db, #3b82f6);">CLIENT</div>
          </div>
          <div class="detail-content">
            <div class="detail-label">对待客户</div>
            <h2 class="detail-heading">以客户为中心，提供卓越服务</h2>
            <div class="detail-divider"></div>
            <p class="detail-text">
              新恒丰集团始终将客户利益放在首位，坚持"专业、诚信、高效"的服务理念。我们致力于为客户提供高质量的咨询服务，帮助客户实现价值最大化，与客户建立长期信赖的合作关系。
            </p>
            <div class="detail-stats">
              <div class="stat-item">
                <span class="stat-num">3700<span class="unit">+</span></span>
                <span class="stat-label">累计服务项目</span>
              </div>
              <div class="stat-item">
                <span class="stat-num">98<span class="unit">%</span></span>
                <span class="stat-label">客户满意度</span>
              </div>
              <div class="stat-item">
                <span class="stat-num">3000<span class="unit">亿</span></span>
                <span class="stat-label">累计投资规模</span>
              </div>
            </div>
          </div>
        </div>

        <div class="detail-block">
          <div class="detail-image">
            <img src="https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=happy%20team%20office%20work%20together%20professional%20business%20people&image_size=landscape_4_3" alt="对待员工">
            <div class="detail-tag" style="background: linear-gradient(135deg, #8b5cf6, #7c3aed);">EMPLOYEE</div>
          </div>
          <div class="detail-content">
            <div class="detail-label">对待员工</div>
            <h2 class="detail-heading">以人为本，共创美好未来</h2>
            <div class="detail-divider"></div>
            <p class="detail-text">
              新恒丰集团视员工为企业最宝贵的财富，致力于为员工提供良好的工作环境、广阔的发展空间和有竞争力的薪酬福利。我们关注员工成长，努力营造温馨、团结、进取的企业文化氛围。
            </p>
            <div class="detail-stats">
              <div class="stat-item">
                <span class="stat-num">260<span class="unit">+</span></span>
                <span class="stat-label">专业技术人员</span>
              </div>
              <div class="stat-item">
                <span class="stat-num">160<span class="unit">+</span></span>
                <span class="stat-label">注册执业人员</span>
              </div>
              <div class="stat-item">
                <span class="stat-num">95<span class="unit">%</span></span>
                <span class="stat-label">员工满意度</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->

  </div>
</template>

<script>
export default {
  name: 'Responsibility',
  data() {
    return {
      responsibilityList: [
        {
          title: '保护环境',
          icon: 'el-icon-odometer',
          description: '积极维护商业生态体系，永远保持与客户及合作伙伴之间的公平关系',
          bgGradient: 'linear-gradient(135deg, #10b981, #059669)'
        },
        {
          title: '回馈社会',
          icon: 'el-icon-user',
          description: '积极参与社会公益事业，通过捐赠、志愿服务等方式回馈社会',
          bgGradient: 'linear-gradient(135deg, #f59e0b, #d97706)'
        },
        {
          title: '对待客户',
          icon: 'el-icon-user',
          description: '以客户为中心，提供专业、诚信、高效的咨询服务，创造最大价值',
          bgGradient: 'linear-gradient(135deg, #1a56db, #3b82f6)'
        },
        {
          title: '对待员工',
          icon: 'el-icon-s-custom',
          description: '以人为本，关注员工成长与福祉，营造温馨团结的企业文化氛围',
          bgGradient: 'linear-gradient(135deg, #8b5cf6, #7c3aed)'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.responsibility-page {
  min-height: 100vh;
  background: #fff;
}

/* ===== Hero Banner ===== */
.responsibility-hero {
  position: relative;
  height: 400px;
  overflow: hidden;
}

.hero-bg {
 position: absolute;
 top: 0;
 left: 0;
 width: 100%;
 height: 100%;
 
 img {
   width: 100%;
   height: 100%;
   object-fit: cover;
 }
}

// .hero-bg::after {
//   content: '';
//   position: absolute;
//   inset: 0;
//   background:
//     linear-gradient(90deg, rgba(12, 27, 59, 0.85) 0%, rgba(26, 58, 110, 0.6) 100%),
//     url('https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=modern%20city%20skyline%20blue%20architecture%20aerial%20view%20professional&image_size=landscape_16_9') center/cover;
// }

.hero-content {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 10%;
}

.hero-title {
  font-size: 52px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 16px;
  position: relative;
  padding-left: 24px;
}

.hero-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 6px;
  height: 60px;
  background: linear-gradient(180deg, #3b82f6, #60a5fa);
  border-radius: 3px;
}

.hero-en-title {
  font-size: 22px;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: 6px;
  font-weight: 300;
}

/* ===== Intro Section ===== */
.intro-section {
  padding: 80px 0;
  background: #fff;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.intro-header {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  position: relative;
}

.intro-watermark {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 120px;
  font-weight: 800;
  color: rgba(26, 86, 219, 0.05);
  letter-spacing: 8px;
  white-space: nowrap;
  pointer-events: none;
}

.intro-title {
  font-size: 36px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 16px;
  position: relative;
  z-index: 1;
}

.intro-divider {
  width: 50px;
  height: 4px;
  background: linear-gradient(90deg, #1a56db, #3b82f6);
  margin: 0 auto 30px;
  border-radius: 2px;
}

.intro-text {
  font-size: 16px;
  color: #475569;
  line-height: 2;
  position: relative;
  z-index: 1;
}

/* ===== Section Header ===== */
.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-title {
  font-size: 36px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 16px;
}

.section-divider {
  width: 50px;
  height: 4px;
  background: linear-gradient(90deg, #1a56db, #3b82f6);
  margin: 0 auto;
  border-radius: 2px;
}

/* ===== Responsibility Cards ===== */
.responsibility-section {
  padding: 80px 0;
  background: #f8fafc;
}

.responsibility-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}

.responsibility-card {
  background: #fff;
  border-radius: 16px;
  padding: 40px 36px;
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #1a56db, #4f46e5);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.12);

    &::before {
      opacity: 1;
    }

    .card-action {
      color: #1a56db;

      i {
        transform: translateX(5px);
      }
    }
  }
}

.card-icon {
  width: 72px;
  height: 72px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);

  i {
    font-size: 32px;
    color: #fff;
  }
}

.card-title {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 14px;
}

.card-desc {
  font-size: 15px;
  color: #64748b;
  line-height: 1.8;
  margin-bottom: 24px;
}

.card-action {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #94a3b8;
  font-weight: 500;
  transition: all 0.3s ease;

  i {
    font-size: 14px;
    transition: transform 0.3s ease;
  }
}

/* ===== Detail Section ===== */
.detail-section {
  padding: 80px 0;
  background: #fff;
}

.detail-block {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  margin-bottom: 80px;

  &:last-child {
    margin-bottom: 0;
  }
}

.detail-image {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);

  &.reverse {
    order: -1;
  }

  img {
    width: 100%;
    height: 360px;
    object-fit: cover;
    display: block;
    transition: transform 0.5s ease;
  }

  &:hover img {
    transform: scale(1.05);
  }
}

.detail-tag {
  position: absolute;
  top: 20px;
  left: 20px;
  padding: 6px 16px;
  border-radius: 20px;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
}

.detail-content {
  padding: 20px 0;
}

.detail-label {
  display: inline-block;
  padding: 6px 16px;
  background: rgba(26, 86, 219, 0.08);
  color: #1a56db;
  font-size: 14px;
  font-weight: 600;
  border-radius: 20px;
  margin-bottom: 20px;
}

.detail-heading {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 16px;
  line-height: 1.3;
}

.detail-divider {
  width: 50px;
  height: 4px;
  background: linear-gradient(90deg, #1a56db, #3b82f6);
  margin-bottom: 24px;
  border-radius: 2px;
}

.detail-text {
  font-size: 15px;
  color: #475569;
  line-height: 2;
  margin-bottom: 32px;
}

.detail-stats {
  display: flex;
  gap: 40px;
  padding-top: 24px;
  border-top: 1px solid #e2e8f0;
}

.stat-item {
  display: flex;
  flex-direction: column;
}

.stat-num {
  font-size: 32px;
  font-weight: 700;
  color: #1a56db;
  line-height: 1;

  .unit {
    font-size: 18px;
    font-weight: 600;
    margin-left: 2px;
  }
}

.stat-label {
  font-size: 13px;
  color: #64748b;
  margin-top: 8px;
}

/* ===== Footer ===== */
.responsibility-footer {
  background: #0c1b3b;
  color: #fff;
  padding-top: 60px;
}

.footer-main {
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  gap: 60px;
  padding-bottom: 40px;
}

.footer-brand {
  padding-right: 20px;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 16px;
}

.logo-circle {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #1a56db, #3b82f6);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    font-size: 28px;
    color: #fff;
  }
}

.logo-info {
  h3 {
    font-size: 22px;
    font-weight: 700;
    margin-bottom: 4px;
  }

  p {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
    letter-spacing: 2px;
  }
}

.footer-links-group {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.footer-link-col {
  h4 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
    color: #fff;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.6);
      padding: 5px 0;
      cursor: pointer;
      transition: color 0.3s ease;

      &:hover {
        color: #fff;
      }
    }
  }
}

.footer-qr {
  text-align: center;
}

.qr-placeholder {
  width: 120px;
  height: 120px;
  background: #fff;
  border-radius: 12px;
  margin: 0 auto 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    font-size: 70px;
    color: #1a56db;
  }
}

.qr-image p {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
}

.footer-bottom-bar {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 24px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.4);
  }

  span {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.4);
  }
}

/* ===== Responsive ===== */
@media (max-width: 992px) {
  .hero-content {
    padding-left: 5%;
  }

  .hero-title {
    font-size: 40px;
  }

  .detail-block {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .detail-image {
    &.reverse {
      order: 0;
    }

    img {
      height: 300px;
    }
  }

  .detail-stats {
    gap: 30px;
  }

  .footer-main {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .footer-links-group {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .responsibility-hero {
    height: 300px;
  }

  .hero-title {
    font-size: 30px;
  }

  .hero-en-title {
    font-size: 16px;
    letter-spacing: 4px;
  }

  .intro-section {
    padding: 60px 0;
  }

  .intro-title {
    font-size: 28px;
  }

  .intro-watermark {
    font-size: 80px;
    top: -20px;
  }

  .responsibility-section {
    padding: 60px 0;
  }

  .responsibility-card {
    padding: 30px 24px;
  }

  .detail-section {
    padding: 60px 0;
  }

  .detail-heading {
    font-size: 26px;
  }

  .detail-image img {
    height: 260px;
  }

  .detail-stats {
    flex-wrap: wrap;
    gap: 24px;
  }

  .stat-num {
    font-size: 26px;
  }

  .section-title {
    font-size: 28px;
  }

  .footer-links-group {
    grid-template-columns: 1fr;
  }

  .footer-bottom-bar {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }
}

/* ===== 移动端补充(grid 断点与 watermark) ===== */
@media (max-width: 768px) {
  .responsibility-grid {
    grid-template-columns: 1fr;
  }

  .intro-watermark {
    font-size: 70px;
    top: -20px;
  }
}

/* ===== 小屏手机适配 ===== */
@media (max-width: 480px) {
  .responsibility-hero {
    height: 240px;
  }

  .hero-title {
    font-size: 24px;
    padding-left: 16px;

    &::before {
      height: 40px;
      width: 4px;
    }
  }

  .hero-en-title {
    font-size: 13px;
    letter-spacing: 3px;
  }

  .intro-section {
    padding: 50px 0;
  }

  .intro-watermark {
    display: none;
  }

  .intro-title {
    font-size: 26px;
  }

  .intro-text {
    font-size: 14px;
    line-height: 1.8;
  }

  .responsibility-section {
    padding: 50px 0;
  }

  .section-title {
    font-size: 24px;
  }

  .responsibility-card {
    padding: 28px 22px;
  }

  .card-icon {
    width: 56px;
    height: 56px;

    i {
      font-size: 26px;
    }
  }

  .card-title {
    font-size: 20px;
  }

  .card-desc {
    font-size: 14px;
    line-height: 1.7;
  }

  .detail-section {
    padding: 50px 0;
  }

  .detail-heading {
    font-size: 22px;
  }

  .detail-image img {
    height: 220px;
  }

  .detail-stats {
    gap: 20px;
  }

  .stat-num {
    font-size: 24px;

    .unit {
      font-size: 15px;
    }
  }
}
</style>